import Popover from "components/Popover";
import { influenceLabels, QuartileBar } from "components/QuartileBar";
import { show as showIntercom } from "helpers/services/intercom";
import useLabels from "hooks/useLabels";

type QuartileProps = {
  quartile: number | null;
};

function Quartile({ quartile }: QuartileProps) {
  if (quartile !== null && ![1, 2, 3, 4].includes(quartile)) {
    throw new Error(
      "Invalid quartile value. Expected a number between 1 and 4."
    );
  }

  const [quartileLabels] = useLabels("quartile");

  return (
    <Popover
      interactive
      widthFull
      maxWidth={334}
      tooltipContent={
        <div className="flex flex-col gap-3 ">
          <p className="sm-bold text-fg-base">
            <span>{quartile ? `Q${quartile}` : "UNKNOWN"}</span>
            <span>&nbsp;</span>
            {quartileLabels["title-quartile"]}
          </p>
          <p className="sm-normal">
            <a
              className="underline"
              target="_blank"
              rel="noreferrer"
              href="https://www.scimagojr.com/journalrank.php"
            >
              {quartileLabels["scimago-journal-rank"]}
            </a>{" "}
            {quartileLabels["description"]}
          </p>
          {!quartile ? (
            <p className="tiny-normal text-fg-muted">
              {quartileLabels["we-could-not-map"]}{" "}
              <a onClick={() => showIntercom()} className="underline">
                here
              </a>
              .
            </p>
          ) : null}
          <div className="pt-3 flex gap-2 justify-between items-center border-t border-t-border-base">
            <QuartileBar quartile={quartile} />
            <div className="tiny-normal text-fg-muted shrink-0">
              <span>{quartile ? `Q${quartile},` : ""}</span>
              &nbsp;
              <span>
                {
                  quartileLabels[
                    `${
                      influenceLabels[
                        `${quartile ? `Q${quartile}` : "UNKNOWN"}`
                      ]
                    }`
                  ]
                }
              </span>
            </div>
          </div>
        </div>
      }
    >
      <div className="flex items-center sm:justify-start sm:gap-x-4 w-full tiny-md text-fg-base gap-x-2">
        <div className="flex flex-wrap sm-normal text-fg-muted shrink-0">
          <span>{quartile ? `Q${quartile}` : "UNKNOWN"}</span>
          <span>&nbsp;</span>
          <span>{quartileLabels["title"]}</span>
        </div>
        {quartile ? <QuartileBar quartile={quartile} /> : null}
      </div>
    </Popover>
  );
}

export default Quartile;
